export const MICROSERVICES = {
    WEBAPP: 'web',
    MOBILE: 'mobile',
  }

export const SOURCES = {
  WEBAPP: 'webapp-frontend',
}